import React, { useEffect, useState } from "react";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";
import { Container, Row, Button, Col, Form } from "react-bootstrap";
import ferryBookImg from "../assets/img/ferry.jpg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ferrySearch } from "../store/slices/ferrybooking";

// boat img
import makruzzLogo from "../assets/img/makruzz.jpg";
import greenoceanLogo from "../assets/img/greenocean.webp";
import nautikaLogo from "../assets/img/watersports2.png";

export default function FerryBooking() {
  const navigate = useNavigate();
  const { state: payload } = useLocation();
  const dispatch = useDispatch();

  const [selectedClasses, setSelectedClasses] = useState({});

  const [formData, setFormData] = useState({
    from: payload.source,
    to: payload.destination,
    date: payload.date,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sailings, setSailings] = useState([]);

  const getSelected = (id) => selectedClasses[id] ?? -1;

  const handleSelect = (ferryId, classIndex) => {
    setSelectedClasses((prev) => ({
      ...prev,
      [ferryId]: classIndex,
    }));
  };

  const providerLogo = {
    Macruzz: makruzzLogo,
    Makruzz: makruzzLogo,
    GreenOcean: greenoceanLogo,
    Nautika: nautikaLogo,
  };

  // fetch data

  useEffect(() => {
    if (!payload) {
      setError("No search data provided.");
      return;
    }

    let isMounted = true;

    const fetchFerries = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await dispatch(ferrySearch(payload)).unwrap();

        console.log("FERRY API RAW RESPONSE:", JSON.stringify(res, null, 2));

        // STEP 1: detect API structure
        const providerBlocks =
          res?.data || res?.ferry?.data || res?.results || res || [];

        const grouped = new Map();

        // Nautika fare key map
        const NAUTIKA_FARE_LABELS = {
          pBaseFare: "Premium",
          bBaseFare: "Business",
        };

        // create unique sailing key
        const makeId = (provider, ferryName, dep, arr) =>
          `${provider}|${ferryName}|${dep}|${arr}`;

        // Ensure array
        const blocks = Array.isArray(providerBlocks)
          ? providerBlocks
          : [providerBlocks];

        // STEP 2: Normalize & group
        for (const block of blocks) {
          const list = Array.isArray(block?.normalized)
            ? block.normalized
            : Array.isArray(block)
            ? block
            : Array.isArray(block?.data)
            ? block.data
            : [block];

          for (const item of list) {
            const provider = block.provider || item.provider || "Unknown";

            const ferryName =
              item.ferryName || item.name || item.tripId || "Ferry";

            const departure = item.departureTime || item.departure || "";

            const arrival = item.arrivalTime || item.arrival || "";

            const key = makeId(provider, ferryName, departure, arrival);

            // Create bucket
            if (!grouped.has(key)) {
              grouped.set(key, {
                id: key,
                provider,
                ferryName,
                img: item.image || item.img || ferryBookImg,
                departureTime: departure,
                arrivalTime: arrival,
                classes: [],
                cta: provider === "Nautika" ? "Select Seats" : "Book Now",
              });
            }

            const bucket = grouped.get(key);

            // STEP 3: If item has classes array
            if (Array.isArray(item.classes) && item.classes.length) {
              item.classes.forEach((cls) => {
                bucket.classes.push({
                  class: cls.class || cls.name || cls.className,
                  price: cls.price || cls.fare || 0,
                  availableSeats: cls.availableSeats ?? cls.seats ?? null,
                  meal: cls.meal ?? false,
                  mealPrice: cls.mealPrice ?? null,
                });
              });
              continue;
            }

            // STEP 4: Nautika fare object
            if (
              item.fares &&
              typeof item.fares === "object" &&
              !Array.isArray(item.fares)
            ) {
              Object.entries(item.fares).forEach(([fareKey, price]) => {
                if (!NAUTIKA_FARE_LABELS[fareKey]) return;
                bucket.classes.push({
                  class: NAUTIKA_FARE_LABELS[fareKey],
                  price,
                  availableSeats: null,
                  meal: false,
                });
              });
              continue;
            }

            // STEP 5: Simple row (GreenOcean / Makruzz)
            if (item.price != null || item.class) {
              bucket.classes.push({
                class: item.class || "Standard",
                price: item.price,
                availableSeats: item.availableSeats ?? item.seats ?? null,
                meal: item.meal ?? false,
                mealPrice: item.mealPrice ?? null,
              });
              continue;
            }
          }
        }

        // STEP 6: Convert to array + sort by departure
        const finalSailings = Array.from(grouped.values()).sort(
          (a, b) =>
            timeToMinutes(a.departureTime) - timeToMinutes(b.departureTime)
        );

        if (isMounted) setSailings(finalSailings);
      } catch (err) {
        console.error("Ferry fetch failed:", err);

        if (isMounted) {
          setError("Failed to load ferries.");
          setSailings([]);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchFerries();
    return () => (isMounted = false);
  }, [dispatch, payload]);

  // Proceed action (CTA)
  const proceed = (sailing) => {
    const selectedIdx = getSelected(sailing.id);
    if (selectedIdx < 0) return;
    const selectedClass = sailing.classes[selectedIdx];
    const route =
      sailing.provider === "Nautika" ? "/booknow" : "/passengerdetails";
    navigate(route, {
      state: {
        sailing,
        selectedClass,
        search: payload ?? formData,
      },
    });
  };

  return (
    <>
      {/*Navbar*/}
      <Navbarsticky />

      <div className="ferrybooking-container"></div>

      <Container className="py-4">
        {/* ==================>  summery <================= */}
        <div className="ferrysummary-box mb-4 d-flex flex-wrap justify-content-between align-items-center">
          <div className="summary-text d-flex flex-row gap-2">
            <span>
              <b>From:</b> {formData.from} &nbsp; | &nbsp;
            </span>
            <span>
              <b>To:</b> {formData.to} &nbsp; | &nbsp;
            </span>
            <span>
              {" "}
              <b>Date:</b> {formData.date}
            </span>
          </div>

          <Link to="/ferry">
            <Button className="edit-btn mt-2 mt-md-0">Edit Search</Button>
          </Link>
        </div>

        {/* ================> ferry list <=============== */}

        {loading && <p className="mx-3">Loading ferry results...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        {!loading && !error && sailings.length === 0 && (
          <p>No ferries found for this route/date.</p>
        )}

        {sailings.map((s, i) => {
          // map internal shape to UI fields used by your markup
          const item = {
            id: s.id ?? String(i),
            provider: s.provider,
            ferryName: s.ferryName,
            img: s.img || ferryBookImg,
            departure: s.departureTime,
            arrival: s.arrivalTime,
            duration:
              s.duration ||
              (s.departureTime && s.arrivalTime
                ? durationText(s.departureTime, s.arrivalTime)
                : ""),
            classes: (s.classes || []).map((c) => ({
              name: c.class ?? c.name ?? "Class",
              seats: c.availableSeats ?? null,
              price: c.price ?? 0,
              meal: c.meal ?? false,
              mealPrice: c.mealPrice ?? null,
            })),
            cta:
              s.cta ?? (s.provider === "Nautika" ? "Select Seats" : "Book Now"),
            providerRaw: s.provider,
          };

          return (
            <div
              key={item.id || i}
              className="ferrybooking-card shadow-sm mb-4"
            >
              <Row className="align-items-center">
                <Col xs={12} md={3} className="text-center p-3">
                  <img
                    src={providerLogo[s.provider] || ferryBookImg}
                    alt=""
                    className="ferrybooking-img"
                  />
                </Col>

                <Col xs={12} md={9} className="p-3">
                  <div className="header-row d-flex justify-content-between align-items-center">
                    <h5 className="provider-title">{item.ferryName}</h5>
                    <span className="provider-badge">{item.provider}</span>
                  </div>

                  <div className="time-row d-flex justify-content-between my-2">
                    <div className="time-block">
                      <div className="time-val">
                        {formatShortTime(item.departure)}
                      </div>
                      <div className="time-label">Departure</div>
                    </div>

                    <div className="ferrybookingduration-badge">
                      {item.duration}
                    </div>

                    <div className="time-block">
                      <div className="time-val">
                        {formatShortTime(item.arrival)}
                      </div>
                      <div className="time-label">Arrival</div>
                    </div>
                  </div>

                  {/* Class List */}
                  <Row className="mt-3">
                    {item.classes.map((cls, index) => {
                      const isSelected = getSelected(item.id) === index;
                      return (
                        <Col md={4} key={index} className="mb-3 ">
                          <div
                            className={`class-box text-center ${
                              isSelected ? "selected-class" : ""
                            }`}
                            onClick={() => handleSelect(item.id, index)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                handleSelect(item.id, index);
                              }
                            }}
                          >
                            <div className="class-name">
                              {cls.name}{" "}
                              {typeof cls.seats === "number"
                                ? `(${cls.seats})`
                                : ""}
                            </div>
                            <div className="class-price">
                              ₹ {Number(cls.price ?? 0).toLocaleString("en-IN")}
                            </div>
                            <div className="class-meal">
                              {cls.meal ? "Meal Available" : "No meal"}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>

                  {/* Bottom   */}
                  <div className="mt-2 class-info-text">
                    {item.classes.length} classes available |
                    {getSelected(item.id) >= 0 ? (
                      <>
                        {" "}
                        Selected:{" "}
                        <strong>
                          {item.classes[getSelected(item.id)].name}
                        </strong>
                      </>
                    ) : (
                      " Select a class"
                    )}
                  </div>

                  <div className="text-end mt-3">
                    {(() => {
                      const sel = getSelected(item.id);
                      const original =
                        sailings.find((x) => x.id === item.id) || s;
                      const isNautika = original.provider === "Nautika";

                      return (
                        <Button
                          className="fb-cta-btn"
                          style={{
                            opacity: sel < 0 ? 0.6 : 1,
                            cursor: sel < 0 ? "not-allowed" : "pointer",
                          }}
                          onClick={() => {
                            if (sel < 0) return;

                            if (isNautika) {
                              proceed(original, "/booknow");
                            } else {
                              proceed(original, "/passengerdetails");
                            }
                          }}
                          disabled={sel < 0}
                          title={
                            sel < 0
                              ? "Select a class first"
                              : isNautika
                              ? "Proceed to seat selection"
                              : "Proceed to booking"
                          }
                        >
                          {isNautika ? "Select Seats" : item.cta}
                        </Button>
                      );
                    })()}
                  </div>
                </Col>
              </Row>
            </div>
          );
        })}
      </Container>
      {/* Footer */}
      <Footer />
    </>
  );
}

/*===================> helpers (kept small) <=================== */

function pad(n) {
  return String(n).padStart(2, "0");
}
function formatShortTime(t = "") {
  const s = String(t || "").trim();
  if (!s) return "";
  // if has am/pm
  if (/am|pm/i.test(s)) {
    const parts = s.replace(/\s?(AM|PM)/i, "").split(":");
    return `${pad(parseInt(parts[0] || "0", 10))}:${pad(
      parseInt(parts[1] || "0", 10)
    )}`;
  }
  const [hh, mm] = s.split(":");
  return `${pad(parseInt(hh || "0", 10))}:${pad(parseInt(mm || "0", 10))}`;
}
function timeToMinutes(t = "") {
  let s = String(t || "").trim();
  const isPM = /pm$/i.test(s);
  const isAM = /am$/i.test(s);
  s = s.replace(/\s?(am|pm)$/i, "");
  const [hhStr, mmStr] = s.split(":");
  let hh = parseInt(hhStr || "0", 10) || 0;
  const mm = parseInt(mmStr || "0", 10) || 0;
  if (isPM && hh < 12) hh += 12;
  if (isAM && hh === 12) hh = 0;
  return hh * 60 + mm;
}
function minutesToHrs(mm) {
  const h = Math.floor(mm / 60);
  const m = mm % 60;
  return `${pad(h)}:${pad(m)} hrs`;
}
function durationText(dep, arr) {
  const d = timeToMinutes(dep);
  const a = timeToMinutes(arr);
  if (Number.isFinite(d) && Number.isFinite(a)) {
    let diff = a - d;
    if (diff < 0) diff += 24 * 60;
    return minutesToHrs(diff);
  }
  return "";
}
